module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 1076
// module chunks = 20